// Re-exported from the shared module to keep this import path stable.
export { default } from '../../shared/components/NewIntroContent';
